import { useOnlineStatus } from '@/shared/hooks/useOnlineStatus';
import '@/app/AppShell.css';

export function OfflineIndicator() {
  const isOnline = useOnlineStatus();

  return (
    <span className="header-status-pill">
      <span className={`header-status-pill__dot header-status-pill__dot--${isOnline ? 'online' : 'offline'}`} aria-hidden="true" />
      {isOnline ? 'Online' : 'Offline — scans saving locally'}
    </span>
  );
}